import { render, staticRenderFns } from "./AgentStockFreeze.vue?vue&type=template&id=b2087490&scoped=true"
import script from "./AgentStockFreeze.vue?vue&type=script&lang=js"
export * from "./AgentStockFreeze.vue?vue&type=script&lang=js"
import style0 from "./AgentStockFreeze.vue?vue&type=style&index=0&id=b2087490&prod&scoped=true&lang=css"
import style1 from "./AgentStockFreeze.vue?vue&type=style&index=1&id=b2087490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2087490",
  null
  
)

export default component.exports